(function () {
  'use strict';

  var SIZE_CHARTS = {

    'men-cotton-t-shirt-size-guide': {
      'S':   { chest: 38, length: 26 },
      'M':   { chest: 40, length: 27 },
      'L':   { chest: 42, length: 28 },
      'XL':  { chest: 44, length: 29 },
      '2XL': { chest: 46, length: 30 }
    },

    'dry-fit-t-shirt-size-guide': {
      'S':   { chest: 38, length: 26 },
      'M':   { chest: 40, length: 27 },
      'L':   { chest: 42, length: 28 },
      'XL':  { chest: 44, length: 29 },
      '2XL': { chest: 46, length: 30 }
    },

    'women-cotton-t-shirt-size-guide': {
      '2XS': { chest: 33, length: 23 },
      'XS':  { chest: 35, length: 24 },
      'S':   { chest: 37, length: 25 },
      'M':   { chest: 39, length: 26 },
      'L':   { chest: 41, length: 27 },
      'XL':  { chest: 43, length: 28 }
    },

    'kids-cotton-t-shirt-size-guide': {
      '5-6Y':   { chest: 26, length: 18.5 },
      '7-8Y':   { chest: 28, length: 19.5 },
      '9-10Y':  { chest: 30, length: 20.5 },
      '11-12Y': { chest: 32, length: 21.5 },
      '13-14Y': { chest: 34, length: 22.5 }
    },

    'kids-co-ord-set-size-guide': {
      '5-6Y':   { chest: 26, length: 18.5 },
      '7-8Y':   { chest: 28, length: 19.5 },
      '9-10Y':  { chest: 30, length: 20.5 },
      '11-12Y': { chest: 32, length: 21.5 },
      '13-14Y': { chest: 34, length: 22.5 }
    },

    'women-crop-cotton-t-shirt-size-guide': {
      '2XS': { chest: 32, length: 16 },
      'XS':  { chest: 34, length: 17 },
      'S':   { chest: 36, length: 18 },
      'M':   { chest: 38, length: 19 },
      'L':   { chest: 40, length: 20 },
      'XL':  { chest: 42, length: 21 }
    }

  };


  function normalizeSize(value) {
    return String(value || '')
      .replace(/^\s+|\s+$/g, '')
      .toUpperCase()
      .replace(/[–—]/g, '-')
      .replace(/\s+/g, '');
  }


  function getParentSection(element) {
    while (element && element !== document) {

      if (
        element.id &&
        element.id.indexOf('shopify-section') === 0
      ) {
        return element;
      }

      element = element.parentNode;
    }

    return null;
  }


  function getVariantPicker(section) {

    if (!section) {
      return null;
    }

    return section.querySelector('variant-picker');
  }


  function getSelectedSize(variantPicker, chart) {

    if (!variantPicker) {
      return null;
    }

    var fieldsets =
      variantPicker.getElementsByTagName('fieldset');

    var i;
    var j;


    /*
     * PRIMARY METHOD
     *
     * Look for the fieldset whose legend contains "size".
     *
     * This supports:
     *
     * Size
     * Size M
     * Size: M
     */
    for (i = 0; i < fieldsets.length; i++) {

      var legend =
        fieldsets[i].getElementsByTagName('legend')[0];

      if (!legend) {
        continue;
      }


      var legendText =
        String(legend.textContent || '')
          .replace(/^\s+|\s+$/g, '')
          .toLowerCase();


      if (legendText.indexOf('size') === -1) {
        continue;
      }


      /*
       * Radio/button size selector
       */
      var inputs =
        fieldsets[i].getElementsByTagName('input');


      for (j = 0; j < inputs.length; j++) {

        if (
          inputs[j].type === 'radio' &&
          inputs[j].checked
        ) {
          return inputs[j].value;
        }

      }


      /*
       * Dropdown inside the same Size fieldset
       */
      var fieldsetSelects =
        fieldsets[i].getElementsByTagName('select');


      if (fieldsetSelects.length > 0) {
        return fieldsetSelects[0].value;
      }

    }


    /*
     * RADIO FALLBACK
     *
     * If Horizon changes how the legend is rendered,
     * check the selected radio values.
     *
     * A value is accepted only if it exists in
     * the current product's size chart.
     *
     * Example:
     *
     * checked options:
     * Navy
     * M
     *
     * Navy = not in chart
     * M = exists in chart
     *
     * therefore M is the selected size.
     */
    if (chart) {

      var allInputs =
        variantPicker.getElementsByTagName('input');


      for (i = 0; i < allInputs.length; i++) {

        if (
          allInputs[i].type === 'radio' &&
          allInputs[i].checked
        ) {

          var normalizedValue =
            normalizeSize(allInputs[i].value);


          if (chart[normalizedValue]) {
            return allInputs[i].value;
          }

        }

      }

    }


    /*
     * DROPDOWN METHOD
     *
     * Used if the product has a dropdown-style
     * variant picker instead of buttons.
     */
    var selects =
      variantPicker.getElementsByTagName('select');

    var labels =
      variantPicker.getElementsByTagName('label');


    for (i = 0; i < selects.length; i++) {

      var select =
        selects[i];

      var isSizeSelect =
        false;


      for (j = 0; j < labels.length; j++) {

        var labelText =
          String(labels[j].textContent || '')
            .replace(/^\s+|\s+$/g, '')
            .toLowerCase();


        if (
          labelText.indexOf('size') !== -1 &&
          (
            labels[j].htmlFor === select.id ||
            labels[j].parentNode === select.parentNode
          )
        ) {

          isSizeSelect = true;
          break;

        }

      }


      if (isSizeSelect) {
        return select.value;
      }

    }


    /*
     * DROPDOWN FALLBACK
     *
     * Same logic as the radio fallback:
     * accept the selected value only if it exists
     * in the current size chart.
     */
    if (chart) {

      for (i = 0; i < selects.length; i++) {

        var normalizedSelectValue =
          normalizeSize(selects[i].value);


        if (chart[normalizedSelectValue]) {
          return selects[i].value;
        }

      }

    }


    return null;
  }


  function updateSizeHelper(helper) {

    if (!helper) {
      return;
    }


    /*
     * FAIL SAFE
     *
     * Start hidden.
     *
     * We reveal the helper only after every required
     * value has been found successfully.
     */
    helper.hidden = true;


    /*
     * Get the size-guide page handle generated by Liquid.
     *
     * Example:
     *
     * dry-fit-t-shirt-size-guide
     */
    var chartHandle =
      String(
        helper.getAttribute('data-size-chart') || ''
      )
        .replace(/^\s+|\s+$/g, '')
        .toLowerCase();


    /*
     * Find the correct measurements.
     */
    var chart =
      SIZE_CHARTS[chartHandle];


    if (!chart) {
      return;
    }


    /*
     * Find the Shopify section containing
     * our measurement helper.
     */
    var section =
      getParentSection(helper);


    if (!section) {
      return;
    }


    /*
     * Find Horizon's variant picker
     * inside the same product section.
     */
    var variantPicker =
      getVariantPicker(section);


    if (!variantPicker) {
      return;
    }


    /*
     * Determine currently selected size.
     */
    var selectedSize =
      normalizeSize(
        getSelectedSize(
          variantPicker,
          chart
        )
      );


    if (!selectedSize) {
      return;
    }


    /*
     * Find the measurement for the selected size.
     */
    var measurement =
      chart[selectedSize];


    if (!measurement) {
      return;
    }


    /*
     * Find the Liquid elements where
     * chest and length must be displayed.
     */
    var chestElement =
      helper.querySelector('[data-size-chest]');

    var lengthElement =
      helper.querySelector('[data-size-length]');


    if (!chestElement || !lengthElement) {
      return;
    }


    /*
     * Insert measurements.
     */
    chestElement.textContent =
      measurement.chest + '"';

    lengthElement.textContent =
      measurement.length + '"';


    /*
     * Everything succeeded.
     *
     * Only now show the helper.
     */
    helper.hidden = false;
  }


  function updateAllSizeHelpers() {

    var helpers =
      document.querySelectorAll(
        '.arteeq-size-helper'
      );

    var i;


    for (i = 0; i < helpers.length; i++) {
      updateSizeHelper(helpers[i]);
    }

  }


  /*
   * SIZE CHANGE LISTENER
   *
   * One listener on document.
   *
   * This is intentionally delegated so it continues
   * working even if Horizon replaces part of the
   * variant picker HTML.
   */
  document.addEventListener(
    'change',
    function (event) {

      var target =
        event.target;


      if (!target) {
        return;
      }


      /*
       * We only care about variant controls.
       */
      if (
        target.tagName !== 'INPUT' &&
        target.tagName !== 'SELECT'
      ) {
        return;
      }


      /*
       * Confirm that the changed control
       * belongs to a variant-picker.
       */
      var parent =
        target;

      var insideVariantPicker =
        false;


      while (
        parent &&
        parent !== document
      ) {

        if (
          parent.tagName &&
          parent.tagName.toLowerCase() ===
            'variant-picker'
        ) {

          insideVariantPicker = true;
          break;

        }


        parent =
          parent.parentNode;
      }


      if (!insideVariantPicker) {
        return;
      }


      /*
       * Find the product section belonging
       * to this variant picker.
       */
      var section =
        getParentSection(target);


      if (!section) {
        return;
      }


      /*
       * Find our measurement helper.
       */
      var helper =
        section.querySelector(
          '.arteeq-size-helper'
        );


      if (!helper) {
        return;
      }


      /*
       * Recalculate measurements.
       */
      updateSizeHelper(helper);

    }
  );


  /*
   * INITIAL PAGE LOAD
   */
  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      updateAllSizeHelpers
    );

  } else {

    updateAllSizeHelpers();

  }


  /*
   * SHOPIFY THEME EDITOR SUPPORT
   */
  document.addEventListener(
    'shopify:section:load',
    updateAllSizeHelpers
  );

})();